import { render, staticRenderFns } from "./ProjectKpi.vue?vue&type=template&id=02b8b5d2"
import script from "./ProjectKpi.vue?vue&type=script&lang=ts"
export * from "./ProjectKpi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports